var _circle, _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusinessIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "url(#paint0_linear_3223_7860)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9988 31.9359C49.8988 31.9193 49.7822 31.9193 49.6822 31.9359C47.3822 31.8526 45.5488 29.9693 45.5488 27.6359C45.5488 25.2526 47.4655 23.3359 49.8488 23.3359C52.2322 23.3359 54.1488 25.2693 54.1488 27.6359C54.1322 29.9693 52.2988 31.8526 49.9988 31.9359Z",
    stroke: "#282828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2805 44.0695C50.5638 44.4529 53.0805 44.0529 54.8471 42.8695C57.1971 41.3029 57.1971 38.7362 54.8471 37.1695C53.0638 35.9862 50.5138 35.5862 48.2305 35.9862",
    stroke: "#282828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9488 31.9359C30.0488 31.9193 30.1655 31.9193 30.2655 31.9359C32.5655 31.8526 34.3988 29.9693 34.3988 27.6359C34.3988 25.2526 32.4822 23.3359 30.0988 23.3359C27.7155 23.3359 25.7988 25.2693 25.7988 27.6359C25.8155 29.9693 27.6488 31.8526 29.9488 31.9359Z",
    stroke: "#282828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6671 44.0695C29.3837 44.4529 26.8671 44.0529 25.1004 42.8695C22.7504 41.3029 22.7504 38.7362 25.1004 37.1695C26.8837 35.9862 29.4337 35.5862 31.7171 35.9862",
    stroke: "#282828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0008 44.3813C39.9008 44.3646 39.7841 44.3646 39.6841 44.3813C37.3841 44.2979 35.5508 42.4146 35.5508 40.0813C35.5508 37.6979 37.4674 35.7812 39.8508 35.7812C42.2341 35.7812 44.1508 37.7146 44.1508 40.0813C44.1341 42.4146 42.3008 44.3146 40.0008 44.3813Z",
    stroke: "#282828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1512 49.6336C32.8012 51.2003 32.8012 53.7669 35.1512 55.3336C37.8178 57.1169 42.1845 57.1169 44.8512 55.3336C47.2012 53.7669 47.2012 51.2003 44.8512 49.6336C42.2012 47.8669 37.8178 47.8669 35.1512 49.6336Z",
    stroke: "#282828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3223_7860",
    x1: 40,
    y1: 63,
    x2: 40,
    y2: 0.00000123704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6F9DA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessIcon);
export default __webpack_public_path__ + "static/media/business_icon.3c8d6d96e1f7e3cf4ce1ccbde4048b43.svg";
export { ForwardRef as ReactComponent };